import RestService from './RestService';
import { ApiRoutes } from './apiRoutes';

/** Per-user "a new monthly FAM feed has been loaded" marker behind the homepage wrapper card (issue #62). */
export type WrappersStatus = {
  current_version: string | null;
  seen_version: string | null;
  has_update: boolean;
};

/** FAM FoF constituents widget (issue #90). */
export type FamConstituent = {
  strumento: string;
  isin: string;
  categoria: string;
  peso: number; // percentage points (4.43 = 4.43%)
};

export type FamConstituents = {
  isin: string;
  data: string; // reference date dd/mm/yyyy
  constituents: FamConstituent[];
  altro_peso: number | null; // summed weight past the top 10
};

export const WrappersService = {
  getStatus: async (): Promise<WrappersStatus> => RestService.get(ApiRoutes.WRAPPERS_STATUS),
  markSeen: async (): Promise<{ seen_version: string | null }> => RestService.put(ApiRoutes.WRAPPERS_SEEN),
  getFamParents: async (): Promise<{ isins: string[] }> => RestService.get(ApiRoutes.WRAPPERS_FAM_PARENTS),
  getFamConstituents: async (isin: string): Promise<FamConstituents> =>
    RestService.get(ApiRoutes.WRAPPERS_FAM_CONSTITUENTS(isin)),
};
